import { CustomFieldResourceType } from "@wingspanhq/payments/dist/interfaces";
import React from "react";
import { RouteComponentProps } from "react-router";
import { WSQueries } from "../../../query/WSQuery";
import { useQueryCustomFieldsAll } from "../../../query/customFields/queries/useQueryCustomFieldsAll";
import { PayableForm } from "../../components/PayableForm/PayableForm";
import { usePayableQuery } from "./PayableDetails";

export const EditPayable: React.FC<
  RouteComponentProps<
    {
      payableId: string;
    },
    any,
    {
      backPath?: string;
    }
  >
> = ({ match, location }) => {
  const payableId = match.params.payableId;
  const payableQuery = usePayableQuery(payableId);
  const queryCustomFields = useQueryCustomFieldsAll({
    resourceType: [CustomFieldResourceType.LineItem]
  });

  const backPath = location.state?.backPath;

  return (
    <WSQueries queries={{ payableQuery, queryCustomFields }}>
      {({
        payableQuery: { data: payable },
        queryCustomFields: { data: customFields }
      }) => (
        <PayableForm
          backPath={backPath}
          payable={payable}
          customFields={customFields}
        />
      )}
    </WSQueries>
  );
};
